export default import.meta.ROLLUP_FILE_URL_BRk2j44E;